import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useCostContext } from './CostProvider';
import { useTranslation } from './i18n';
import { customizedType } from '../helpers/localeHelper';

const PickerModalError = ({ error, onTryAgain, type = '' }) => {
  const { t } = useTranslation();
  const { terminologies } = useCostContext();
  // no permission
  if (error && error.status === 403) {
    return (
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.NO_PERMISSION}
        description={t('NO_PERMISSION', {
          type: customizedType(t, type, terminologies),
        })}
      />
    );
  }

  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION_GREY}
      description={t('ERROR_LOADING', {
        type: customizedType(t, type, terminologies),
      })}
    >
      <LinkButton onClick={onTryAgain}>{t('TRY_AGAIN')}</LinkButton>
    </EmptyState>
  );
};

export default PickerModalError;
